export default __webpack_public_path__ + "static/media/advisory-board-img3.67864897.jpg";